module.exports = __webpack_public_path__ + "static/media/Shri-Gokulnathji-Ke-Vachnam.b27319f9.jpg";